import { WinningData } from '@/services/table/tableState';
import { Card } from '@/services/table/tableTypes';
import { FC } from 'react';
import { checkWinningCard } from '../../utils/checkWinningCard';
import { motion } from 'framer-motion';
import CardFace, { CardSizes } from '@/components/CardFace/CardFace';

const GuestCards: FC<{
  isMobileView: boolean;
  winningData?: WinningData;
  holeCards?: Card[];
  cardAreFanned?: boolean;
}> = ({ isMobileView, winningData, holeCards, cardAreFanned }) => {
  if (!holeCards || holeCards.length === 0) {
    return null;
  }

  return (
    <div className="absolute z-0 mb-2 ml-9 mt-6 flex items-center justify-center gap-2">
      {holeCards.map((card: Card, index) => {
        const isUnknown = card.rank === '?' && card.suit === '?';
        const isWinnerCard = winningData?.cards && checkWinningCard(card, winningData.cards);

        return (
          <motion.div
            key={`option-${card.rank}-${card.suit}-${index}`}
            initial={{ y: 50, rotate: 75, zoom: 1.2 }}
            animate={{ y: 0, zoom: isWinnerCard ? 1.1 : 1, rotate: 0 }}
            transition={{ duration: isWinnerCard ? 0 : 0.6 }}
          >
            <CardFace
              rank={card.rank}
              suit={card.suit}
              isOverlap
              isWinner={isWinnerCard}
              isElevated={!isUnknown}
              handCardIndex={index}
              size={
                isMobileView ? (!isUnknown ? CardSizes.lg : CardSizes.md) : !isUnknown ? CardSizes.xl : CardSizes.md
              }
              cardAreFanned={cardAreFanned}
              totalCards={holeCards.length}
            />
          </motion.div>
        );
      })}
    </div>
  );
};

export default GuestCards;
